import script from "./range-selector.vue?vue&type=script&lang=ts&setup=true"
export * from "./range-selector.vue?vue&type=script&lang=ts&setup=true"

import "./range-selector.vue?vue&type=style&index=0&id=401bb45a&lang=scss"

const __exports__ = script;

export default __exports__